import { createQueryHook } from '~/shared/providers/api';

export const useNextCheckNumber = createQueryHook(
  'finance.nextCheckNumber',
  (params: { financialAccountId: string }) => ({
    financeNextCheckNumber: {
      __args: {
        financialAccountId: params.financialAccountId,
      },
    },
  }),
  {
    select: (data): string => data?.financeNextCheckNumber ?? '',
  },
);
